import React from "react";
import { useNavigate } from "react-router-dom";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import AWSReportsCards from "@/components/organisms/AWSReportsCards";

function AWSAgents() {
  const navigate = useNavigate();

  const agentCards = [
    {
      title: "HealthOps",
      description: "Specialized agent for monitoring and analyzing critical events from the AWS Health Events Dashboard. Provides real-time information on infrastructure health status, identifies critical events, and can execute automatic notifications to account owners and cloud teams",
      action: () => navigate("/aws/agents/healthops"),
      enabled: true,
      icon: "🤖",
      actionText: "Open Chat"
    }
  ];

  return (
    <AWSReportsTemplate title="AWS Agents" showBackButton={false}>
      <AWSReportsCards reportCards={agentCards} />
    </AWSReportsTemplate>
  );
}

export default AWSAgents;